import { createContext } from 'react';

export interface AgentContextType {
  /** Whether this agent is currently active in the chat session */
  isEnabled: boolean;
}

export const AgentContext = createContext<AgentContextType>({
  isEnabled: false,
});
